import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Translate} from "app/services/translate";

export const Benefit = ({icon, content, showMore, showMoreTarget}) => {
    useEffect(() => {
        window.dispatchEvent(new CustomEvent('dialog-new-trigger', {
            detail: {
                target: showMoreTarget
            }
        }));
    }, []);

    return (
        <div className="calculator-benefit">
            {icon}
            {content}
            {showMore && (
                <button className="benefit-button" type="button" data-dialog={showMoreTarget}>
                    {Translate('commons_more')}...
                </button>
            )}
        </div>
    );
};
Benefit.propTypes = {
    icon: PropTypes.any,
    content: PropTypes.any,
    showMore: PropTypes.bool,
    showMoreTarget: PropTypes.string,
}